import React, { useEffect, useState } from "react";
import http from "../../../http";
// import Modal from "react-modal";
import MaterialTable from "material-table";
import Swal from "sweetalert2";
import useLanguage from "../../../Components/language/useLanguage";
import { Modal as ReactModal } from "../../../Components/Common/Modal";
import { FaPlusCircle, FaRegEdit } from "react-icons/fa";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { FiTrash } from "react-icons/fi";
import { ledgerEntryLang } from "../../../Components/language/pages/ledgerEntryLang";
import { FaMinusCircle } from "react-icons/fa";
import AuthUser from "../../../Components/AuthUser";
export default function LedgerEntry() {
  const [update, setUpdate] = useState("members");
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [ledgerHead, setLedgerHead] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const lan = useLanguage(ledgerEntryLang);
  const [ledgers, setLedgers] = useState([
    { id: "", ledger_head_id: "", amount: 0, ledger_category_id: "" },
  ]);
  useEffect(() => {
    http.get(`ledger-entry`).then((res) => {
      setData(res.data || []);
      setIsLoading(false);
    });
    http.get(`ledger-head`).then((res) => {
      setLedgerHead(res.data || []);
    });
    http.get(`payment-method`).then((res) => {
      setPaymentMethod(res.data || []);
    });
  }, [update]);
  const columns = [
    {
      title: lan?.sl,
      field: "",
      render: (row) => (
        <div className="text-center">{row.tableData.id + 1}</div>
      ),
      width: "20 !important",
    },

    {
      title: lan?.transactionNumber,
      field: `transaction_number`,
    },
    {
      title: lan?.transactionDate,
      field: ``,
      render: (row) => (
        <div>{moment(row?.transaction_date).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      title: lan?.paymentMethod,
      field: `payment_method`,
    },
    {
      title: lan?.entryDate,
      field: ``,
      render: (row) => (
        <div>{moment(row?.entry_date).format("DD/MM/YYYY")}</div>
      ),
    },

    {
      title: lan?.action,
      field: "patient",
      render: (row) => (
        <div className="text-center">
          <button
            onClick={() => editData(row)}
            className="btn btn-sm action-btn ms-1"
          >
            <FaRegEdit fontSize={18} />
          </button>
          &nbsp;
          <button
            onClick={() => deleteRowData(row.id)}
            className="btn btn-sm action-btn"
          >
            <FiTrash fontSize={18} />
          </button>
        </div>
      ),
      cellStyle: {
        width: "5%",
        textAlign: "center",
      },
    },
  ];
  const [member, setMember] = useState({
    member_id: "",
    transaction_date: new Date(),
    payment_method: "",
  });
  const [isOpen, setIsOpen] = useState(false);

  const { user } = AuthUser();
  const handleSubmit = () => {
    if (member?.id) {
      http
        .put(`ledger-entry/${member?.id}`, {
          ...member,
          ledgers: ledgers,
          created_by: user?.name,
        })
        .then((res) => {
          if (res.data.status === 200) {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: `Ledger Entry Saved Successfully`,
              timer: 2500,
            });

            setIsOpen(false);
            setUpdate(!update);
            setMember({
              member_id: "",
              transaction_date: new Date(),
            });
          } else {
            Swal.fire({
              position: "top-center",
              icon: "error",
              title: `Something went wrong`,
              timer: 2500,
            });
          }
        });
    } else {
      http
        .post("ledger-entry", {
          ...member,
          ledgers: ledgers,
          created_by: user?.name,
        })
        .then((res) => {
          if (res.data.status === 200) {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: `Ledger Entry Saved Successfully`,
              timer: 2500,
            });

            setIsOpen(false);
            setUpdate(!update);
            setMember({
              member_id: "",
              transaction_date: new Date(),
            });
          } else {
            Swal.fire({
              position: "top-center",
              icon: "error",
              title: `Something went wrong`,
              timer: 2500,
            });
          }
        });
    }
  };

  const handleMonthChange = (e, i) => {
    const { name, value } = e.target;
    const exist = [...ledgers];
    exist[i][name] = value;
    setLedgers(exist);
  };
  const handleLedgerChange = (e, i) => {
    const { id, category_id } = e;
    const exist = [...ledgers];
    exist[i]["ledger_head_id"] = id;
    exist[i]["ledger_category_id"] = category_id;
    setLedgers(exist);
  };
  const editData = (data) => {
    setMember({
      ...member,
      ...data,
    });
    setLedgers(data.details || []);
    setIsOpen(true);
  };
  const closeRowData = (id) => {
    Swal.fire({
      title: lan?.warning,
      text: lan?.youWontRevertIt,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes Close it!",
    }).then((result) => {
      if (result.isConfirmed) {
        http.post(`close-sales-target/${id}`).then((res) => {
          setUpdate(!update);
          setIsOpen(false);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    });
  };
  const deleteRowData = (id) => {
    Swal.fire({
      title: lan?.warning,
      text: lan?.youWontRevertIt,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: lan?.yes,
    }).then((result) => {
      if (result.isConfirmed) {
        http.post(`delete-sales-target/${id}`).then((res) => {
          setUpdate(!update);
          setIsOpen(false);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    });
  };
  const closeModal = () => {
    setIsOpen(false);
    setMember({
      member_id: "",
      transaction_date: new Date(),
      member_type: "dealer",
    });
  };
  const handleAdd = () => {
    const exist = [...ledgers];
    exist.push({
      id: "",
      ledger_head_id: "",
      amount: 0,
      ledger_category_id: "",
    });
    setLedgers(exist);
  };
  const handleRemove = (item, index) => {
    if (item?.id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          http
            .delete(`delete-ledger-details/${item?.id}`)
            .then((res) => {
              setUpdate(!update);
              Swal.fire({
                position: "top-center",
                icon: "success",
                title: "Success !",
                showConfirmButton: false,
                timer: 1500,
              });
              const exist = [...ledgers];
              exist.splice(index, 1);
              setLedgers(exist);
            })
            .catch((err) => {
              console.log(err);
              Swal.fire({
                position: "top-center",
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    } else {
      const exist = [...ledgers];
      exist.splice(index, 1);
      setLedgers(exist);
    }
  };
  console.log(ledgers);
  return (
    <div className="page-content adjustment-type-table">
      <div className="custom-card p-2 d-flex justify-content-between mb-2 align-items-center">
        <h6>{lan?.pageTitle}</h6>
        <div>
          <button
            style={{ marginTop: "1px" }}
            onClick={() => setIsOpen(true)}
            className="btn btn-sm btn-primary float-end"
          >
            {lan?.add}
          </button>
        </div>
      </div>
      <div className="data-table-container">
        <MaterialTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          options={{
            search: true,
            showTitle: false,
            searchFieldAlignment: "left",
            pageSize: 10,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [5, 10, 20, 50, 100],
          }}
        />
      </div>

      <ReactModal isOpen={isOpen} onClose={closeModal} size="md" width="100%">
        <ReactModal.Header onClose={closeModal}>
          <ReactModal.Title>{lan?.createLedgerEntry}</ReactModal.Title>
        </ReactModal.Header>
        <ReactModal.Body styles={{ minHeight: "400px" }}>
          <div className="product_modal">
            <div className="new-member-reg p-2">
              <div className="row">
                <div className="col-6">
                  <div className="form-group mb-2">
                    <label>
                      {lan?.selectDate}
                      <span className="text-danger"> *</span>
                    </label>
                    <ReactDatePicker
                      className="form-control form-control-sm"
                      selected={
                        member?.transaction_date
                          ? new Date(member?.transaction_date)
                          : new Date()
                      }
                      dateFormat="dd/mm/yyyy"
                      onChange={(date) => {
                        setMember({
                          ...member,
                          transaction_date: date,
                        });
                      }}
                      tabIndex={-1}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group mb-2">
                    <label>
                      {lan?.selectPaymentMethod}
                      <span className="text-danger"> *</span>
                    </label>
                    <Select
                      options={paymentMethod}
                      placeholder={lan?.select}
                      onChange={(e) =>
                        setMember({
                          ...member,
                          payment_method: e.name,
                        })
                      }
                      getOptionLabel={(unPaidInvoices) =>
                        `${unPaidInvoices.name}`
                      }
                      getOptionValue={(unPaidInvoices) =>
                        `${unPaidInvoices.id}`
                      }
                      value={paymentMethod?.filter(
                        (unPaidInvoices) =>
                          unPaidInvoices.name === member?.payment_method
                      )}
                    />
                  </div>
                </div>
                <h6 className="my-2">{lan?.enterLedgerDetails}</h6>
                {ledgers?.map((item, index) => (
                  <div className="col-12" key={index}>
                    <div className="row mb-2">
                      <div className="col-6">
                        <Select
                          options={ledgerHead}
                          placeholder={lan?.selectLedger}
                          onChange={(e) => handleLedgerChange(e, index)}
                          getOptionLabel={(unPaidInvoices) =>
                            `${unPaidInvoices.name}`
                          }
                          getOptionValue={(unPaidInvoices) =>
                            `${unPaidInvoices.id}`
                          }
                          value={ledgerHead?.filter(
                            (unPaidInvoices) =>
                              unPaidInvoices.id === Number(item?.ledger_head_id)
                          )}
                        />
                      </div>
                      <div className="col-4">
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          name="amount"
                          value={item?.amount > 0 ? item?.amount : ""}
                          onChange={(e) => handleMonthChange(e, index)}
                          placeholder="Enter Amount"
                        />
                      </div>
                      <div className="col-2">
                        <div className="flex align-items-center justify-content-end mt-1">
                          <FaMinusCircle
                            fontSize={22}
                            className="text-danger me-2 cursor-pointer"
                            onClick={() => handleRemove(item, index)}
                          />
                          {ledgers?.length - 1 === index && (
                            <FaPlusCircle
                              fontSize={22}
                              className="text-success cursor-pointer"
                              onClick={handleAdd}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ReactModal.Body>
        <ReactModal.Footer>
          <button onClick={handleSubmit} className="btn btn-sm btn-primary">
            {" "}
            Save
          </button>
        </ReactModal.Footer>
      </ReactModal>
    </div>
  );
}
